// extracted by mini-css-extract-plugin
var _1 = "FdF9y";
var _2 = "w28UZ";
export { _1 as "disabled", _2 as "reason" }
